const MIN_OWN_CONTRIBUTION_PERCENT = 20;
const TERM_MIN = 24;
const TERM_MAX = 96;
const RESIDUAL_MINMAX_TABLE_LESS = [
	{ minTerm: 12, maxTerm: 23, residualMinPercentage: 30, residualMaxPercentage: 50 },
	{ minTerm: 24, maxTerm: 35, residualMinPercentage: 25, residualMaxPercentage: 40 },
	{ minTerm: 36, maxTerm: 47, residualMinPercentage: 20, residualMaxPercentage: 35 },
	{ minTerm: 48, maxTerm: 59, residualMinPercentage: 15, residualMaxPercentage: 30 },
	{ minTerm: 60, maxTerm: 71, residualMinPercentage: 10, residualMaxPercentage: 25 },
	{ minTerm: 72, maxTerm: 83, residualMinPercentage: 10, residualMaxPercentage: 15 },
	{ minTerm: 84, maxTerm: 96, residualMinPercentage: 5, residualMaxPercentage: 5 }
];
const RESIDUAL_MINMAX_TABLE_MORE = [
	{ minTerm: 12, maxTerm: 23, residualMinPercentage: 30, residualMaxPercentage: 40 },
	{ minTerm: 24, maxTerm: 35, residualMinPercentage: 20, residualMaxPercentage: 30 },
	{ minTerm: 36, maxTerm: 47, residualMinPercentage: 15, residualMaxPercentage: 30 },
	{ minTerm: 48, maxTerm: 59, residualMinPercentage: 10, residualMaxPercentage: 25 },
	{ minTerm: 60, maxTerm: 71, residualMinPercentage: 10, residualMaxPercentage: 20 },
	{ minTerm: 72, maxTerm: 83, residualMinPercentage: 5, residualMaxPercentage: 10 },
	{ minTerm: 84, maxTerm: 96, residualMinPercentage: 5, residualMaxPercentage: 5 }
];
const RESIDUAL_LIMIT = 12000000;
const BUSINESS_USAGE_LIMITS = { MIN: 0, MAX: 100 };
const YIELD_LIMITS = { MIN: 0, MAX: 50 };
const MIN_CONTRIBUTION_PERCENTAGE = 20;
const NET_PRICE_DIVISOR = 1.27;
const OPEN_ENDED_RESULT = 'Nyíltvégű pénzügyi lízing';
const CLOSED_ENDED_RESULT = 'Zártvégű pénzügyi lízing';

export const useConstants = () => ({
	MIN_OWN_CONTRIBUTION_PERCENT,
	TERM_MIN,
	TERM_MAX,
	RESIDUAL_MINMAX_TABLE_LESS,
	RESIDUAL_MINMAX_TABLE_MORE,
	RESIDUAL_LIMIT,
	BUSINESS_USAGE_LIMITS,
	YIELD_LIMITS,
	OPEN_ENDED_RESULT,
	CLOSED_ENDED_RESULT,
	MIN_CONTRIBUTION_PERCENTAGE,
	NET_PRICE_DIVISOR
});
